import { render, staticRenderFns } from "./CollectionContacts.vue?vue&type=template&id=2cf228cb&scoped=true&"
import script from "./CollectionContacts.vue?vue&type=script&lang=ts&"
export * from "./CollectionContacts.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionContacts.vue?vue&type=style&index=0&id=2cf228cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf228cb",
  null
  
)

export default component.exports